package com.essntl.uikit.components.toggle

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.tween
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsSmallIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsTabItem(
    isSelected: Boolean,
    onClick: () -> Unit,
    tabWidth: Dp,
    tabState: TabState,
) {
    val tabContentColor: Color by animateColorAsState(
        targetValue = if (isSelected) {
            MaterialTheme.esColorScheme.textContrast
        } else {
            MaterialTheme.esColorScheme.iconSecondary
        },
        animationSpec = tween(easing = LinearEasing),
    )
    Row(
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .clip(CircleShape)
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                enabled = tabState.enabled
            ) {
                onClick()
            }
            .width(tabWidth)
            .padding(
                vertical = 6.dp,
            )
    ) {
        Text(
            modifier = Modifier,
            text = tabState.text,
            color = tabContentColor,
            textAlign = TextAlign.Center,
            style = MaterialTheme.esTypography.p2Medium14,
        )

        if (tabState.suffix != null) {
            Spacer(modifier = Modifier.width(1.spacing))
            EsSmallIcon(
                res = tabState.suffix,
                tint = tabContentColor
            )
        }
    }
}
